import { jsx as _jsx } from "react/jsx-runtime";
var ArrowUp = function ArrowUp(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M5.232 10.64a1 1 0 0 0 1.408.128L11 7.135V19a1 1 0 0 0 2 0V7.135l4.36 3.633a1 1 0 1 0 1.28-1.536l-6-5c-.047-.04-.103-.059-.155-.089-.041-.024-.077-.052-.122-.07A.992.992 0 0 0 12 4a.992.992 0 0 0-.363.073c-.045.018-.081.046-.122.07-.052.03-.108.05-.155.09l-6 5a1 1 0 0 0-.128 1.407Z",
      fill: color
    })
  });
};
export default ArrowUp;